import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, map, tap } from 'rxjs';
// import config from './config.json';
import { environment as config } from '../environments/environment';
import { Location } from "@angular/common";
import { Router } from '@angular/router';
import { AlertService } from './views/shared/alert/alert.service';
// data.model.ts
export interface DataPayload {
  isToggled: boolean;
  callCare: any;
}

@Injectable({
  providedIn: 'root'
})
export class AppService {
  // Loader observable

  private readonly tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  private showLoaderEvt = new Subject<boolean>();
  showLoaderEvt$ = this.showLoaderEvt.asObservable();


  public isCase = new BehaviorSubject<any>(null);
  isCase$ = this.isCase.asObservable();
  public sideNavToggle = new BehaviorSubject<DataPayload>({ isToggled: false, callCare: '' });
  sideNavToggle$ = this.sideNavToggle.asObservable();

  public sideNavActionBtnSub = new Subject<any>();
  sideNavActionBtnSub$ = this.sideNavActionBtnSub.asObservable();

  public unitStatusData = new BehaviorSubject<any>(null);
  unitStatusData$ = this.unitStatusData.asObservable();

  public cadStatusData = new BehaviorSubject<any>(null);
  cadStatusData$ = this.cadStatusData.asObservable();

  public customerId = new BehaviorSubject<any>(null);
  customerId$ = this.customerId.asObservable();

  public tabName = new BehaviorSubject<any>(null);
  tabName$ = this.tabName.asObservable();

  public dynamicHeader = new BehaviorSubject<any>(null);
  dynamicHeader$ = this.dynamicHeader.asObservable();

  public closeCase = new BehaviorSubject<any>(null);
  closeCase$ = this.closeCase.asObservable();

  public caseData = new BehaviorSubject<any>(null);
  caseData$ = this.caseData.asObservable();


  public addEditForm = new BehaviorSubject<any>(null);
  addEditForm$ = this.addEditForm.asObservable();

  private commonSubject = new BehaviorSubject<Object>(false);
  commonSubject$ = this.commonSubject.asObservable();

  public customerTab = new BehaviorSubject<any>(null);
  customerTab$ = this.customerTab.asObservable();


  public userDetails = new BehaviorSubject<any>(null);
  userDetails$ = this.userDetails.asObservable();

  public caseEdited = new BehaviorSubject<any>(null);
  caseEdited$ = this.caseEdited.asObservable();


  public viewuserDetails = new BehaviorSubject<any>(null);
  viewuserDetails$ = this.viewuserDetails.asObservable();

  public loginData = new BehaviorSubject<any>(null);
  loginData$ = this.loginData.asObservable();


  public editedCase = new BehaviorSubject<any>(null);
  editedCase$ = this.editedCase.asObservable();



  public callSSEStream = new Subject<any>();

  public dynamicDataSource = new BehaviorSubject<any>(null);  // Default value is null
  dynamicData$ = this.dynamicDataSource.asObservable();  // Observable to subscribe to

  public rightNavToggle = new BehaviorSubject<any>(null);
  rightNavToggle$ = this.rightNavToggle.asObservable();

  /** Outbound phone number to pre-fill in custom dialer */
  public outboundDialNumber = new BehaviorSubject<string | null>(null);
  outboundDialNumber$ = this.outboundDialNumber.asObservable();

  /** CCP (Dialer) open state - true when open, false when closed */
  public ccpOpened = new BehaviorSubject<boolean>(false);
  ccpOpened$ = this.ccpOpened.asObservable();

  public callEnded = new Subject<string>();
  callEnded$ = this.callEnded.asObservable();

  public showIncomingTab = new BehaviorSubject<boolean>(false);
  showIncomingTab$ = this.showIncomingTab.asObservable();

  public incomingCallerInfo = new BehaviorSubject<any>(null);
  incomingCallerInfo$ = this.incomingCallerInfo.asObservable();

  /** Centralized AWS Connect contact state */
  public activeContact = new BehaviorSubject<any>(null);
  activeContact$ = this.activeContact.asObservable();

  public incomingContact = new BehaviorSubject<any>(null);
  incomingContact$ = this.incomingContact.asObservable();

  /** Emits when incoming call should open Add/Edit Customer. Payload: { found, callerName, callerPhoneNumber, customer? } */
  public openCustomerFromIncomingCall = new BehaviorSubject<any>(null);
  openCustomerFromIncomingCall$ = this.openCustomerFromIncomingCall.asObservable();

  /** Customer data for Edit User form when opened from incoming call (avoids extra API call) */
  public openEditFormWithCustomerData = new BehaviorSubject<any>(null);
  openEditFormWithCustomerData$ = this.openEditFormWithCustomerData.asObservable();

  private email: string | null = null;

  private showTable: boolean = false;

  setEmail(email: string) {
    this.email = email;
  }

  getEmail(): string | null {
    return this.email;
  }
  setCustomer(email: string) {
    this.email = email;
  }

  getCustomer(): string | null {
    return this.email;
  }
  showTables(email: boolean) {
    this.showTable = email;
  }

  getTable(): boolean {
    return this.showTable;
  }

  updateDynamicData(newData: any): void {
    this.dynamicDataSource.next(newData);  // Push the new data to subscribers
  }

  // setActiveTab(tab: any) {
  //   this.activeTabSubject.next(tab);
  // }

  sideNavHashRouting(value: any) {
    this.sideNavActionBtnSub.next(value);
  }

  callCommonObservable(value: Object) {
    this.commonSubject.next(value);
  }

  public baseUrl = config.urls.apiUrl;
  constructor(public http: HttpClient, public alertService: AlertService, public location: Location, public router: Router, public zone: NgZone, public alertServices: AlertService) {
  }

  protected get requestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage['authToken'] || '{}',
      'Accept': 'application/json, text/plain, */*',
      // 'sessionId': JSON.parse(localStorage['authToken'] ?? '{}').sessionId ?? 0,
      'Content-Type': 'application/json'
    });

    return { headers };
  }
  protected get requestHeaders1(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + (localStorage['authToken'] || ''),
      'Accept': 'application/json, text/plain, */*'
      // Do NOT set Content-Type here when sending FormData
    });

    return { headers };
  }
  manageLoader(x: any) {
    this.showLoaderEvt.next(x);
  }


  login(username: string, password: string) {
    const body = { username, password };

    return this.http.post('https://tscti-demo.my.connect.aws/login', body);
  }

  // sessionExpirePopUpSubjectFun(state: boolean = false) {
  //   this.sessionExpiredSubject.next(state);
  // }
  get<T>(endpoint: string): Observable<T> {
    this.manageLoader(true);
    return this.http.get<T>(`${this.baseUrl}/${endpoint}`, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }

  getApiStatic<T>(endpoint: string): Observable<T> {
    this.manageLoader(true);
    return this.http.get<T>(`https://demo.coh.tscerp.com/${endpoint}`, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }


  getDatas<T>(endpoint: string, data: any): Observable<T> {
    this.manageLoader(true);
    return this.http.get<T>(`${this.baseUrl}/${endpoint + data}`, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }
  sendErrorMessage(status: string) {
    switch (status) {
      case '500':
        this.alertServices.error('Internal server error');
        break;
      case '401':
        this.alertServices.error('Session expired');
        break;
      default:
        this.alertServices.error('An unexpected error occurred');
    }
  }




  getMenu<T>(endpoint: string): Observable<T> {
    this.manageLoader(true);
    return this.http.get<T>(`${this.baseUrl}/${endpoint}`, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }
  postStack<T>(endpoint: string, data: any): Observable<T> {
    this.manageLoader(true);
    return this.http.post<T>(`${endpoint}`, data, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }
  post<T>(endpoint: string, data: any, showLoader: boolean = true): Observable<T> {
    this.manageLoader(showLoader);
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, data, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }


  post1<T>(endpoint: string, data: any, showLoader: boolean = true): Observable<T> {
    this.manageLoader(showLoader);
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, data, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }

  upload<T>(endpoint: string, data: FormData): Observable<T> {
    this.manageLoader(true);
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, data, this.requestHeaders1)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          this.manageLoader(false);
          throw error;
        })
      );
  }


  put<T>(endpoint: string, data: any): Observable<T> {
    this.manageLoader(true);
    return this.http.put<T>(`${this.baseUrl}/${endpoint}`, data, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          console.error('Error fetching data', error);
          this.manageLoader(false);
          throw error;
        })
      );
  }

  delete<T>(endpoint: string): Observable<T> {
    this.manageLoader(true);
    return this.http.delete<T>(`${this.baseUrl}/${endpoint}`, this.requestHeaders)
      .pipe(
        map(response => {
          this.manageLoader(false);
          return response;
        }),
        catchError(error => {
          this.manageLoader(false);
          throw error;
        })
      );
  }

  public eventSource!: XMLHttpRequest;

  // callSSE(endpoint: string) {
  //   this.eventSource = new XMLHttpRequest();
  //   this.eventSource.open('GET', `http://GTC-VM-162.GTC.local:9192/${endpoint}`, true);

  //   this.eventSource.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage['authToken'] ?? '{}').accessToken);
  //   this.eventSource.setRequestHeader('Accept', 'application/json, text/plain, */*');
  //   this.eventSource.setRequestHeader('sessionId', '240000278'); // Replace with your actual session ID
  //   this.eventSource.setRequestHeader('Content-Type', 'application/json');

  //   this.eventSource.responseType = 'text';

  //   this.eventSource.onreadystatechange = () => {
  //     if (this.eventSource.status === 200) {
  //         this.callSSEStream.next(this.eventSource.responseText); // Emit the latest parsed data;
  //     }
  //   };

  //   this.eventSource.send();
  // }




  callSSE(endpoint: string): Observable<any> {
    return new Observable((observer) => {
      const eventSource = new XMLHttpRequest();
      eventSource.open('GET', `http://GTC-VM-162.GTC.local:9192/${endpoint}`, true);

      eventSource.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage['authToken'] ?? '{}').accessToken);
      eventSource.setRequestHeader('Accept', 'application/json, text/plain, */*');
      eventSource.setRequestHeader('sessionId', '240000278'); // Replace with your actual session ID
      eventSource.setRequestHeader('Content-Type', 'application/json');

      eventSource.responseType = 'text';

      eventSource.onreadystatechange = () => {
        if (eventSource.readyState === XMLHttpRequest.DONE && eventSource.status === 200) {
          observer.next(eventSource.responseText); // Emit the response text
          observer.complete();
        } else if (eventSource.readyState === XMLHttpRequest.DONE) {
          observer.error(eventSource.statusText || 'Request failed');
        }
      };

      eventSource.onerror = () => {
        observer.error('A network error occurred');
      };

      eventSource.send();
    });
  }


  disconnect() {
    if (this.eventSource) {
      this.eventSource.abort();
    }
  }

  getData(): Observable<any> {
    return this.callSSEStream.asObservable();
  }

  goBack() {
    this.location.back();
  }

  currentModuleName() {
    return this.router.url.toLowerCase().includes('cad') ? 'cad' : this.router.url.toLowerCase().includes('aes') ? 'aes' : '';
  }


  private readonly apiUrl3 = 'api/Auth/revertToAccountManager'

  backToAM(id: any): Observable<any> {
    return this.http.get<any>(this.apiUrl3 + '/' + `${id}`).pipe(
      tap(response => {
        // Store the access token in localStorage
        localStorage.setItem('access_token', response.access_token);
        this.tokenSubject.next(response.access_token);
        this.startSessionTimeOut()
      })
    );
  }
  startSessionTimeOut() {
    setTimeout(() => {
      this.logout();
    }, 3600000);
  }
  logout() {
    this.router.navigate(['login'])
    this.alertService.warning('session expired')
    localStorage.removeItem('authToken');
    localStorage.removeItem('userDetails');
    localStorage.removeItem('appUserID');
    localStorage.removeItem('customerID');
    localStorage.removeItem('caseID');
    this.tokenSubject.next(null);
  }

  /** Chat goes through backend proxy (api/ChatBot/chat) to avoid CORS when calling Lambda directly */
  postApiChatBot<T>(data: any): Observable<T> {
    const endpoint = 'api/ChatBot/chat';
    const payload = {
      message: data?.message ?? '',
      session_id: data?.session_id ?? 'unique-session-id'
    };
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, payload, this.requestHeaders).pipe(
      catchError(error => {
        console.error('ChatBot API Error', error);
        throw error;
      })
    );
  }

  postApiAgentChatBot<T>(data: any): Observable<T> {
    const endpoint = 'documents/search';
    const payload = {
      "query": data.query
    };
    return this.http.post<T>(`https://demo.coh.tscerp.com/${endpoint}`, payload, this.requestHeaders).pipe(
      catchError(error => {
        console.error('ChatBot API Error', error);
        throw error;
      })
    );
  }

  uploadExcelCustomers(file: FormData): Observable<HttpEvent<any>> {
    const endpoint = 'api/CustomerProfile/uploadExcelCustomers';
    const token = localStorage.getItem('authToken');

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token || ''}`
    });

    return this.http.post(`${this.baseUrl}/${endpoint}`, file, {
      headers,
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    });
  }


}